import { defineMessages } from 'react-intl';

export default defineMessages({
    coverages: {
        id: 'policycommon.component.policy-common-coverables.Coverages',
        defaultMessage: 'Coverages'
    }
});
